var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworkSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-3.5 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.456 18.098v-2.623h-7.343v-1.573h4.721v-10.489h-10.49v10.489h4.721v1.573h-7.343v2.623h-4.721v10.49h10.49v-10.49h-4.721v-1.574h13.637v1.574h-4.721v10.49h10.49v-10.49h-4.721zM8.392 4.462h8.392v8.391h-8.392v-8.391zM9.441 27.539h-8.392v-8.392h8.392l-0 8.392zM24.128 27.539h-8.392v-8.392h8.392v8.392z",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkSvgrepoCom);
export default __webpack_public_path__ + "static/media/network-svgrepo-com.26cb943ce8f5329dd38f9ba9abb56193.svg";
export { ForwardRef as ReactComponent };